/**
 * Util that exploits JS default arguments to assert an argument.
 *
 * @deprecated Use {@link import('cadenza/utils/custom-error').assert} instead
 * to provide a better error message.
 */
export function isRequired () {
  throw new Error('Parameter is required');
}
